import { DSText, DSTextInput } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

type ResponsibleReceivingProps = {
  methods: any
  accountKey: number
}

export const ResponsibleReceiving = ({
  methods,
  accountKey
}: ResponsibleReceivingProps) => {
  return (
    <>
      <Controller
        key={accountKey}
        name='responsavelRecebimento'
        control={methods.control}
        rules={{
          required: 'Responsável pelo recebimento é obrigatório'
        }}
        render={({ field: { onChange, value } }) => (
          <DSTextInput
            value={value}
            onChange={option => {
              onChange(option)
            }}
            placeholder='Digite o nome completo'
            label='Responsável pelo recebimento*'
            maxLength={100}
          />
        )}
      />
      {typeof methods.formState.errors.responsavelRecebimento?.message ===
        'string' && (
        <DSText as='span' size='sm' weight='semibold' color='errorLight'>
          {methods.formState.errors.responsavelRecebimento.message}
        </DSText>
      )}
    </>
  )
}
